module.exports = __webpack_public_path__ + "static/media/header_realtalkb73340d1ffadfe127fa8e38934ec1b28.webp";